// const barrio = "asdad"
const barrios = [
  {
      "value": 0,
      "label": "Ciudad Autónoma de Buenos Aires"
  },
  {
      "value": 1,
      "label": "Vicente López"
  },
  {
      "value": 2,
      "label": "Olivos"
  },
  {
      "value": 3,
      "label": "Munro"
  },
  {
      "value": 4,
      "label": "La Lucila"
  },
  {
      "value": 5,
      "label": "Carapachay"
  },
  {
      "value": 6,
      "label": "Villa Martelli"
  },
  {
      "value": 7,
      "label": "Villa Adelina"
  },
  {
      "value": 8,
      "label": "Florida"
  },
  {
      "value": 9,
      "label": "Florida Oeste"
  },
]
// const barrios = [
//     { "value": "Agronomía", "label": "Agronomía" },
//     { "value": "Almagro", "label": "Almagro" },
//     { "value": "Balvanera", "label": "Balvanera" },
//     { "value": "Barracas", "label": "Barracas" },
//     { "value": "Belgrano", "label": "Belgrano" },
//     { "value": "Boedo", "label": "Boedo" },
//     { "value": "Caballito", "label": "Caballito" },
//     { "value": "Chacarita", "label": "Chacarita" },
//     { "value": "Coghlan", "label": "Coghlan" },
//     { "value": "Colegiales", "label": "Colegiales" },
//     { "value": "Constitución", "label": "Constitución" },
//     { "value": "Flores", "label": "Flores" },
//     { "value": "Floresta", "label": "Floresta" },
//     { "value": "La Boca", "label": "La Boca" },
//     { "value": "La Paternal", "label": "La Paternal" },
//     { "value": "Liniers", "label": "Liniers" },
//     { "value": "Mataderos", "label": "Mataderos" },
//     { "value": "Monte Castro", "label": "Monte Castro" },
//     { "value": "Monserrat", "label": "Monserrat (originalmente llamado Montserrat)" },
//     { "value": "Nueva Pompeya", "label": "Nueva Pompeya" },
//     { "value": "Núñez", "label": "Núñez" },
//     { "value": "Palermo", "label": "Palermo" },
//     { "value": "Parque Avellaneda", "label": "Parque Avellaneda" },
//     { "value": "Parque Chacabuco", "label": "Parque Chacabuco" },
//     { "value": "Parque Chas", "label": "Parque Chas" },
//     { "value": "Parque Patricios", "label": "Parque Patricios" },
//     { "value": "Puerto Madero", "label": "Puerto Madero" },
//     { "value": "Recoleta", "label": "Recoleta" },
//     { "value": "Retiro", "label": "Retiro" },
//     { "value": "Saavedra", "label": "Saavedra" },
//     { "value": "San Cristóbal", "label": "San Cristóbal" },
//     { "value": "San Nicolás", "label": "San Nicolás" },
//     { "value": "San Telmo", "label": "San Telmo" },
//     { "value": "Vélez Sársfield", "label": "Vélez Sársfield" },
//     { "value": "Versalles", "label": "Versalles" },
//     { "value": "Villa Crespo", "label": "Villa Crespo" },
//     { "value": "Villa del Parque", "label": "Villa del Parque" },
//     { "value": "Villa Devoto", "label": "Villa Devoto" },
//     { "value": "Villa General Mitre", "label": "Villa General Mitre" },
//     { "value": "Villa Lugano", "label": "Villa Lugano" },
//     { "value": "Villa Luro", "label": "Villa Luro" },
//     { "value": "Villa Ortúzar", "label": "Villa Ortúzar" },
//     { "value": "Villa Pueyrredón", "label": "Villa Pueyrredón" },
//     { "value": "Villa Real", "label": "Villa Real" },
//     { "value": "Villa Riachuelo", "label": "Villa Riachuelo" },
//     { "value": "Villa Santa Rita", "label": "Villa Santa Rita" },
//     { "value": "Villa Soldati", "label": "Villa Soldati" },
//     { "value": "Villa Urquiza", "label": "Villa Urquiza" },
//     { value: 'Beccar', label: 'Beccar' },
//     { value: 'Acassuso', label: 'Acassuso' },
//     { value: 'Boulogne', label: 'Boulogne' },
//     { value: 'San Isidro', label: 'San Isidro' },
//     { value: 'Martínez', label: 'Martínez' },
//     { value: 'Vicente López', label: 'Vicente López' },
//     { value: 'Olivos', label: 'Olivos' },
//     { value: 'Munro', label: 'Munro' },
//     { value: 'La Lucila', label: 'La Lucila' },
//     { value: 'Carapachay', label: 'Carapachay' },
//     { value: 'Villa Martelli', label: 'Villa Martelli' },
//     { value: 'Villa Adelina', label: 'Villa Adelina' },
//     { value: 'Florida Este', label: 'Florida Este' },
//     { value: 'Florida Oeste', label: 'Florida Oeste' },
//   ]

  // const barriosDeBA = () => {
  //   return barrio;
  // }

  const barrio = barrios.slice().sort((a, b) => a.label.localeCompare(b.label));
  barrio.push({ value: 99, label: 'Otros...' });

export {
  barrio,
}